import React, { useContext } from 'react';
import Pagination from 'modules/common/components/Pagination';
import GenericList from 'modules/common/components/GenericList';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import {
  reactSelectFilterStyle,
  reactSelectCustomStyle,
} from 'modules/common/components/Select';
import FilterListIcon from '@material-ui/icons/FilterList';
import SortIcon from '@material-ui/icons/Sort';
import { OTHER_FEES_FEETYPE_OPTIONS, OTHER_FEES_TYPE_OPTIONS } from '../constants';
import CmsContext from '../../../context/CmsContext';

const statusOption = [
  { label: 'ALL STATUS', value: '' },
  { label: 'ISSUED', value: 'ISSUED' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'FOR PAYMENT', value: 'FOR PAYMENT' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR EVALUATION', value: 'FOR CHECKING' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'FOR PAYMENT CONFIRMATION', value: 'FOR PAYMENT CONFIRMATION' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'PROCESSING', value: 'PROCESSING' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'PAID', value: 'PAID' },
];

function GenericListPair({
  moduleName,
  setKeyword,
  keyword,
  keywordPlaceholder,
  listName,
  label,
  renderItem,
  isLoading,
  selected,
  data,
  dataPager,
  handleSelectRow,
  renderContent,
  statusFilter,
  setStatusFilter,
  status,
  noSearch,
  searchButton,
  searchButtonLabel,
  addButton,
  addButtonLabel,
  customFilter,
  selectedKey,
  downloadCSV,
  statusOptions,
  notificationListConfig,
  certificateFilter,
  is_generated,
  handleSelectFilter,
  filterOption,
  handleSort,
  handleChangePage,
  hasOtherFeesFilter,
  handleOnChange,
  otherFeesFeeType,
  otherFeesType,
  yearOptions,
  setYearFilter,
  year,
  hasYearFilter,
  endorsingOfficeOptions,
  setEndorsingOfficeFilter,
  endorsingOffice,
  hasEndorsingOfficeFilter,
  setEndorsingOfficeStatus,
  endorsingOfficeStatus,
  endorsingOfficeStatusOptions,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const renderPlaceholder = (type) => {
    const icons = {
      filter: <FilterListIcon />,
      sort: <SortIcon />,
    };

    if (!icons[type]) return null;

    return (
      <div className="d-flex align-items-center">
        {icons[type]}
        <span
          className="ml-1"
          style={{ fontSize: 10, textTransform: 'uppercase' }}
        >
          {type === 'filter' ? 'Filter' : 'Sort'}
        </span>
      </div>
    );
  };

  const renderDownloadButton = () => {
    if (!downloadCSV) return null;

    const buttonText = _.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2')
      ? 'Registrants/ Subscribers'
      : 'Subscribers List';

    return (
      <div className="download-csv d-flex align-items-center px-3">
        <button
          type="button"
          onClick={downloadCSV}
          className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary w-100"
          style={{ color: 'white' }}
        >
          {`Download ${buttonText}`}
        </button>
      </div>
    );
  };

  const renderSearchInput = () => {
    if (noSearch) return null;

    return (
      <div className="form-wrapper d-flex align-items-center search-container">
        <i className="fas fa-search icon-search mr-2" />
        <input
          className="search-input w-100"
          type="text"
          name="q"
          id="keyword"
          placeholder={keywordPlaceholder}
          onChange={setKeyword}
          value={keyword || ''}
          required
        />
      </div>
    );
  };

  const handleOtherFeeChange = (option, key) => {
    const { value } = option;
    handleOnChange(key, value);
  };

  const renderFilters = () => {
    if (!statusFilter) return null;

    if (hasOtherFeesFilter) {
      return (
        <div
          className="d-flex align-items-center justify-content-end my-3"
          style={{ gap: '1rem' }}
        >
          <div className="d-flex align-items-center" style={{ gap: '.5rem' }}>
            <label className="form-label mt-2 mb-0">
              <span className="text-muted">
                <h6>Fee Type</h6>
              </span>
            </label>
            <Select
              styles={reactSelectFilterStyle}
              value={
                OTHER_FEES_FEETYPE_OPTIONS.find(
                  (item) => otherFeesFeeType === item.value
                ) || ''
              }
              onChange={(e) => handleOtherFeeChange(e, 'fee_type')}
              options={OTHER_FEES_FEETYPE_OPTIONS}
            />
          </div>

          <div className="d-flex align-items-center" style={{ gap: '.5rem' }}>
            <label className="form-label mt-2 mb-0">
              <span className="text-muted">
                <h6>Type</h6>
              </span>
            </label>
            <Select
              name="type"
              styles={reactSelectFilterStyle}
              value={
                OTHER_FEES_TYPE_OPTIONS.find(
                  (item) => otherFeesType === item.value
                ) || ''
              }
              onChange={(e) => handleOtherFeeChange(e, 'type')}
              options={OTHER_FEES_TYPE_OPTIONS}
            />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="d-flex align-items-center justify-content-end my-3">
          {certificateFilter && (
            <div className="d-flex align-items-center">
              <label className="form-label mt-2 mb-0">
                <span className="text-muted">
                  <h6>Type</h6>
                </span>
              </label>
              <Select
                styles={reactSelectCustomStyle}
                value={
                  filterOption.find(
                    (item) => is_generated === _.get(item, 'value')
                  ) || ''
                }
                onChange={handleSelectFilter}
                options={filterOption}
              />
            </div>
          )}

          <Select
            styles={reactSelectFilterStyle}
            className="mr-2"
            placeholder={renderPlaceholder('filter')}
            value={
              (statusOptions || statusOption).find(
                (item) => status === _.get(item, 'value')
              ) || ''
            }
            onChange={setStatusFilter}
            options={statusOptions || statusOption}
          />
          
          {hasYearFilter && (
            <Select
              styles={reactSelectFilterStyle}
              className="mr-2"
              placeholder={renderPlaceholder('filter')}
              value={
                (yearOptions).find(
                  (item) => year === _.get(item, 'value')
                ) || ''
              }
              onChange={setYearFilter}
              options={yearOptions}
            />
          )}
          
          <Select
            styles={reactSelectFilterStyle}
            placeholder={renderPlaceholder('sort')}
            onChange={handleSort}
            options={[
              { label: 'ASCENDING', value: 'asc' },
              { label: 'DESCENDING', value: 'desc' },
            ]}
          />
        </div>
        {hasEndorsingOfficeFilter && (
          <div className='d-flex align-items-center justify-content-end my-3'>
            <Select
              styles={reactSelectFilterStyle}
              className="mr-2"
              placeholder={renderPlaceholder('filter')}
              value={
                (endorsingOfficeOptions).find(
                  (item) => endorsingOffice === _.get(item, 'value')
                ) || ''
              }
              onChange={setEndorsingOfficeFilter}
              options={endorsingOfficeOptions}
            />
            <Select
              styles={reactSelectFilterStyle}
              placeholder={renderPlaceholder('endorsing_status')}
              value={
                (endorsingOfficeStatusOptions).find(
                  (item) => endorsingOfficeStatus === _.get(item, 'value')
                ) || ''
              }
              onChange={setEndorsingOfficeStatus}
              options={endorsingOfficeStatusOptions}
            />
          </div>
        )}
      </React.Fragment>
    );
  };

  const renderActionButton = (onClick, btnLabel, icon) => {
    if (!onClick) return null;

    return (
      <button
        type="button"
        onClick={onClick}
        className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold mx-auto mb-3"
      >
        {btnLabel} <i className={`fas fa-${icon}`} />
      </button>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* LEFT SECTION */}
        <div className="col-4 p-0">
          <div className="card-main card left-section sticky p-0 section-listing">
            <div className="container-fluid card-section-content px-0">
              <div className="list-name">{moduleName}</div>
              {renderDownloadButton()}
              <div className="search-filter">
                {renderSearchInput()}
                {renderFilters()}
                {customFilter}
              </div>
              <div className="transaction-list flex-grow-1">
                <GenericList
                  height={100}
                  listName={listName}
                  label={label}
                  labelKey={renderItem}
                  isLoading={isLoading}
                  selected={selected.toString()}
                  data={data}
                  pagerData={dataPager}
                  rowsCount={dataPager.count || 0}
                  onSelectRow={handleSelectRow}
                  selectedKey={selectedKey}
                  notificationListConfig={notificationListConfig}
                />
              </div>
              <div className="list-pagination">
                <div className="d-flex justify-content-center text-center align-item-center">
                  <Pagination data={dataPager} onChange={handleChangePage} />
                </div>
              </div>

              {renderActionButton(addButton, addButtonLabel, 'plus')}
              {renderActionButton(searchButton, searchButtonLabel, 'search')}
            </div>
          </div>
        </div>
        <div className="col-8 p-0">
          {/* RIGHT SECTION */}
          <div className="card-main card right-section">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
}

GenericListPair.defaultProps = {
  moduleName: 'Transaction List',
  setKeyword: () => {},
  keyword: '',
  downloadCSV: null,
  status: '',
  setStatusFilter: () => {},
  keywordPlaceholder: '',
  statusFilter: false,
  noSearch: false,
  listName: '',
  label: '',
  renderItem: '',
  isLoading: false,
  selected: '',
  data: [],
  dataPager: {
    total: 0,
    total_pages: 0,
  },
  handleSelectRow: () => {},
  renderContent: () => {},
  addButton: null,
  addButtonLabel: 'Add',
  searchButton: null,
  searchButtonLabel: 'Search',
  customFilter: undefined,
  selectedKey: 'id',
  statusOptions: null,
  notificationListConfig: () => {},
  certificateFilter: false,
  is_generated: '',
  handleSelectFilter: () => {},
  filterOption: null,
  handleSort: () => {},
  handleChangePage: () => {},
  hasOtherFeesFilter: false,
  handleOnChange: () => {},
  otherFeesFeeType: '',
  otherFeesType: '',
  setYearFilter: () => {},
  yearOptions: null,
  year: '',
  hasYearFilter: false,
  setEndorsingOfficeFilter: () => {},
  endorsingOfficeOptions: null,
  endorsingOffice: '',
  hasEndorsingOfficeFilter: false,
  setEndorsingOfficeStatus: () => {},
  endorsingOfficeStatus: '',
  endorsingOfficeStatusOptions: null,
};

GenericListPair.propTypes = {
  setKeyword: PropTypes.instanceOf(Function),
  setStatusFilter: PropTypes.instanceOf(Function),
  keyword: PropTypes.string,
  downloadCSV: PropTypes.instanceOf(Function),
  moduleName: PropTypes.string,
  status: PropTypes.string,
  keywordPlaceholder: PropTypes.string,
  listName: PropTypes.string,
  label: PropTypes.string,
  renderItem: PropTypes.instanceOf(Function),
  isLoading: PropTypes.bool,
  statusFilter: PropTypes.bool,
  selected: PropTypes.string,
  noSearch: PropTypes.bool,
  data: PropTypes.instanceOf(Array),
  dataPager: PropTypes.instanceOf(Object),
  handleSelectRow: PropTypes.instanceOf(Function),
  renderContent: PropTypes.instanceOf(Function),
  addButton: PropTypes.func,
  addButtonLabel: PropTypes.string,
  searchButton: PropTypes.func,
  searchButtonLabel: PropTypes.string,
  customFilter: PropTypes.node,
  selectedKey: PropTypes.string,
  statusOptions: PropTypes.instanceOf(Array),
  notificationListConfig: PropTypes.instanceOf(Function),
  certificateFilter: PropTypes.bool,
  is_generated: PropTypes.string,
  handleSelectFilter: PropTypes.instanceOf(Function),
  filterOption: PropTypes.instanceOf(Array),
  handleSort: PropTypes.instanceOf(Function),
  handleChangePage: PropTypes.instanceOf(Function),
  hasOtherFeesFilter: PropTypes.bool,
  handleOnChange: PropTypes.instanceOf(Function),
  otherFeesFeeType: PropTypes.string,
  otherFeesType: PropTypes.string,
  setYearFilter: PropTypes.instanceOf(Function),
  yearOptions: PropTypes.instanceOf(Array),
  year: PropTypes.string,
  hasYearFilter: PropTypes.bool,
  setEndorsingOfficeFilter: PropTypes.instanceOf(Function),
  endorsingOfficeOptions: PropTypes.instanceOf(Array),
  endorsingOffice: PropTypes.string,
  hasEndorsingOfficeFilter: PropTypes.bool,
  setEndorsingOfficeStatus: PropTypes.instanceOf(Function),
  endorsingOfficeStatus: PropTypes.string,
  endorsingOfficeStatusOptions: PropTypes.instanceOf(Array),
};

export default GenericListPair;
